import React, { useState, useEffect } from 'react';

import { Box, Grid, Typography, Link, CircularProgress } from '@mui/material';
import { callApi } from 'src/core/callApi';
import { useParams } from 'react-router-dom';
import { COLOR_PRIMARY, COLOR_RED } from 'src/const';

import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import CloseIcon from '@mui/icons-material/Close';

const EmailVerify = () => {
  let { hashCode } = useParams<{ hashCode: string }>();
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const callVerifyLambda = async () => {
    const url = 'https://nucx2ebwi6.execute-api.us-east-2.amazonaws.com/default/verifyUser';
    const config = {
      queryParams: {
        magic_link: hashCode,
        action: 'verify_magic_link',
      },
    };
    const resp = await callApi(url, config, false);
    if (!resp.error) {
      setIsVerified(true);
      setIsLoading(false);
    } else {
      setIsVerified(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    callVerifyLambda();
  }, []);

  // - circular spinner
  if (isLoading) {
    return (
      <Box
        sx={{
          height: '100vh',
          width: '100%',
        }}
      >
        <Grid container alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
          <Grid item>
            <CircularProgress size={80} />
          </Grid>
        </Grid>
      </Box>
    );
  }

  // - main body
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      spacing={4}
      style={{ height: '100vh' }}
    >
      <Grid item justifyContent="center">
        <MarkEmailReadIcon style={{ fontSize: '120px', color: COLOR_PRIMARY }} />
      </Grid>

      <Grid item justifyContent="center">
        <Typography variant="h5" style={{ fontWeight: 'bold', fontSize: '24px' }}>
          {isVerified ? 'Success!' : 'Failed!'}
        </Typography>
      </Grid>

      <Grid item justifyContent="center">
        <Typography variant="body1" style={{ color: '#6B6B6B', fontSize: '20px' }}>
          {isVerified
            ? 'Thanks for verifying your email!'
            : 'This link is either expired or invalid!'}
        </Typography>
      </Grid>

      <Box
        sx={{
          position: 'absolute',
          top: '20px',
          right: '20px',
        }}
      >
        <Link href="/airbnb-data?searchPage=true" color={COLOR_RED}>
          <CloseIcon sx={{ fontSize: '60px', cursor: 'pointer' }} />
        </Link>
      </Box>
    </Grid>
  );
};

export default EmailVerify;
